import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import AppShell from './components/layout/AppShell'
import ProtectedRoute from './components/layout/ProtectedRoute'
import AdminProtectedRoute from './components/layout/AdminProtectedRoute'
import Login from './pages/Login'
import Home from './pages/Home'
import Respond from './pages/Respond'
import MyResponses from './pages/MyResponses'
import Upload from './pages/Upload'
import Knowledge from './pages/Knowledge'
import Themes from './pages/Themes'
import Initiatives from './pages/Initiatives'
import InitiativeDetail from './pages/InitiativeDetail'
import CatalogBrowser from './pages/catalog/CatalogBrowser'
import CatalogEntryDetail from './pages/catalog/CatalogEntryDetail'
import DimensionView from './pages/catalog/DimensionView'
import MatrixView from './pages/catalog/MatrixView'
import TaxonomyReview from './pages/catalog/TaxonomyReview'
import InitiativeQueue from './pages/admin/InitiativeQueue'
import Intersections from './pages/admin/Intersections'

// Phase 2 routes (per MERGE_PLAN §9):
//   Member: /, /initiatives/:slug/respond, /me/responses
//   Admin:  /admin/initiatives/:slug/queue, plus /catalog, /upload, /knowledge
//   (admin-only per §14.6 / §14.7)
//
// Removed in Phase 2: /interviews, /interviews/:id (the legacy interview-
// session conductor — sessions don't exist anymore).

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        {/* Member surface */}
        <Route index element={<Home />} />
        <Route path="initiatives/:slug/respond" element={<Respond />} />
        <Route path="me/responses" element={<MyResponses />} />

        {/* Initiative index + detail are admin-only. Members reach the
            respond flow from Home; they no longer browse initiative pages. */}
        <Route
          path="initiatives"
          element={
            <AdminProtectedRoute>
              <Initiatives />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="initiatives/:slug"
          element={
            <AdminProtectedRoute>
              <InitiativeDetail />
            </AdminProtectedRoute>
          }
        />

        {/* Admin-only surfaces */}
        <Route
          path="upload"
          element={
            <AdminProtectedRoute>
              <Upload />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="knowledge"
          element={
            <AdminProtectedRoute>
              <Knowledge />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="knowledge/themes"
          element={
            <AdminProtectedRoute>
              <Themes />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="catalog"
          element={
            <AdminProtectedRoute>
              <CatalogBrowser />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="catalog/matrix"
          element={
            <AdminProtectedRoute>
              <MatrixView />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="catalog/view/:dimensionSlug"
          element={
            <AdminProtectedRoute>
              <DimensionView />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="catalog/review"
          element={
            <AdminProtectedRoute>
              <TaxonomyReview />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="catalog/:id"
          element={
            <AdminProtectedRoute>
              <CatalogEntryDetail />
            </AdminProtectedRoute>
          }
        />

        {/* Admin queue editor */}
        <Route
          path="admin/initiatives/:slug/queue"
          element={
            <AdminProtectedRoute>
              <InitiativeQueue />
            </AdminProtectedRoute>
          }
        />

        {/* Admin intersections viewer (Phase 3) */}
        <Route
          path="admin/initiatives/:slug/intersections"
          element={
            <AdminProtectedRoute>
              <Intersections />
            </AdminProtectedRoute>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
